<div id="footer">

    <div id="contentFooter" *ngIf="!diviceXs">

        <div id="contentFooterGeneral" fxLayout="row" fxLayoutAlign="space-around start">
            <div id="helpCenter" fxFlex="20">
                <h3>Centro Ayuda</h3>

                <ul>
                    <li>Chat</li>

                    <li>Preguntas Frecuentes</li>

                    <li>Políticas de Cambios y Devoluciones</li>

                    <li>Contacto</li>
                </ul>
            </div>

            <div id="legalInformation">
                <h3>Información legal</h3>

                <ul>
                    <li>Legales del día </li>
                    <li>Términos y condiciones </li>
                    <li>Términos y condiciones marketplace </li>
                    <li>Políticas de privacidad </li>
                    <li>Políticas de Información </li>
                    <li>Superintendencia de Industria y Comercio - SIC </li>
                    <li>Derecho de retracto </li>
                    <li>Solicitud de Reversiones </li>
                </ul>
            </div>

            <div id="informationOfInterest">
                <h3>Información de interés</h3>

                <ul>
                    <li>tuGessi.com </li>
                    <li>Garantía Extendida </li>
                    <li>Punto Entrega </li>
                    <li>Paute con nosotros </li>
                    <li>Ventas empresariales</li>
                </ul>
            </div>

            <div id="socialMedia">
                <h3>Siguenos</h3>
                <a id="facebook">
                    <figure></figure>
                </a>
                <a id="twitter">
                    <figure></figure>
                </a>
            </div>
        </div>

        <div id="payMethod">
            <h3>Medios de pago</h3>
            <figure></figure>
        </div>
    </div>

    <div id="contentFooter" *ngIf="diviceXs">

        <div id="contentFooterGeneral" fxLayout="column" fxLayoutAlign="none center">
            <div id="helpCenter">
                <h3>Centro Ayuda</h3>

                <ul>
                    <li>Chat</li>

                    <li>Preguntas Frecuentes</li>

                    <li>Políticas de Cambios y Devoluciones</li>

                    <li>Contacto</li>
                </ul>
            </div>

            <div id="legalInformation">
                <h3>Información legal</h3>

                <ul>
                    <li>Legales del día</li>
                    <li>Términos y condiciones</li>
                    <li>Términos y condiciones marketplace</li>
                    <li>Políticas de privacidad </li>
                    <li>Políticas de Información </li>
                    <li>Superintendencia de Industria y Comercio - SIC</li>
                    <li>Derecho de retracto</li>
                    <li>Solicitud de Reversiones</li>
                </ul>
            </div>

            <div id="informationOfInterest">
                <h3>Información de interés</h3>

                <ul>
                    <li>tuGessi.com </li>
                    <li>Garantía Extendida</li>
                    <li>Punto Entrega</li>
                    <li>Paute con nosotros </li>
                    <li>Ventas empresariales</li>
                </ul>
            </div>

            <div id="socialMedia">
                <h3>Siguenos</h3>

                <div id=socialMediaIcons fxLayout="row" fxLayoutAlign="space-around center">
                    <a id="facebook">
                        <figure></figure>
                    </a>
                    <a id="twitter">
                        <figure></figure>
                    </a>
                </div>
            </div>

            <div id="payMethod">
                <h3>Medios de pago</h3>
                <figure></figure>
            </div>
        </div>

        <p>{{year}} tuGessi.com ® marca registrada de TuGessi.com S.A.S NIT = 901217626-1. Todos los derechos reservados.
        </p>
    </div>